export const serviceMapper = {
  minors: 'Children',
  alcohol: 'Alcohol' // Only for example
};
